module.exports = __webpack_public_path__ + "static/img/theme_01.d6d8e17f.png";